import { render, staticRenderFns } from "./SecurityDashboard.vue?vue&type=template&id=b07e62f4"
import script from "./SecurityDashboard.vue?vue&type=script&lang=js"
export * from "./SecurityDashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard_style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports